import { DashboardPageLink } from 'dashboard/views/DashboardSandboxHomeView/constants';
import Button from 'design-system/components/Button';
import Spacer from 'design-system/components/Spacer';
import { Paragraph } from 'design-system/components/Text';

interface RequestProductionAccessStepProps {
  isStepCompleted: boolean;
}

const RequestProductionAccessStep = ({ isStepCompleted }: RequestProductionAccessStepProps) => {
  return (
    <>
      {isStepCompleted ? (
        <Paragraph color='primary'>
          Thanks for requesting Production access! You can move onto the next step.
        </Paragraph>
      ) : (
        <>
          <Paragraph color='primary'>
            You’re close to the finish line! You’ve now had a taste of what your Persona solution
            can do with mocked sample data in the Sandbox environment.
          </Paragraph>
          <Spacer height={2} />
          <Paragraph color='primary'>
            Now, let’s test with live data by requesting access to a <b>Production</b> environment
            by choosing one of our plans.
          </Paragraph>
          <Spacer height={2} />
          <Button
            id='home-sandbox-onboarding-checklist__completed-step-request-production-access'
            width='auto'
            onClick={() => {
              window.open(DashboardPageLink.Billing);
            }}
          >
            Request Production access
          </Button>
        </>
      )}
    </>
  );
};

export default RequestProductionAccessStep;
